// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"1f7ce2dd","523":"e39ebd72","633":"ae7a77ec"}[chunkId] + ".chunk.js";
};